import type { SkeletonProps } from './Skeleton.props';
import { SkeletonRoot } from './Skeleton.styles';

const Skeleton = ({
  animation = 'wave',
  'aria-hidden': ariaHidden = true,
  variant = 'rect',
  ...props
}: SkeletonProps) => (
  <SkeletonRoot
    animation={animation}
    aria-hidden={ariaHidden}
    skeletonVariant={variant}
    {...props}
  />
);

export default Skeleton;
